import { render, staticRenderFns } from "./index.vue?vue&type=template&id=abc60d4a&class=full-heigth"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=abc60d4a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abc60d4a')) {
      api.createRecord('abc60d4a', component.options)
    } else {
      api.reload('abc60d4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=abc60d4a&class=full-heigth", function () {
      api.rerender('abc60d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/application/index.vue"
export default component.exports